<template>
  <div :style="cssVariables" class="slices-separator">
    <slot></slot>
  </div>
</template>

<script>
export default {
  props: {
    marginTop: {
      type: Number,
      default: 0
    },
    marginBottom: {
      type: Number,
      default: 0
    }
  },
  computed: {
    cssVariables() {
      return `
        --margin-top: ${this.marginTop}px;
        --margin-bottom: ${this.marginBottom}px;
      `;
    }
  }
};
</script>
<style lang="scss" scoped>
.slices-separator {
  margin-top: var(--margin-top);
  margin-bottom: var(--margin-bottom);
}
</style>
